import React, { useCallback, useEffect, useState } from 'react';

import ContactAddressEdit from '@components/shared/contact_addresses/ContactAddressEdit';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';

import { contactAddressService } from '@services/operator/contactAddressService';

interface ContactAddressLoadedPayload {
  merchant_id?: string | null;
  merchant?: { id?: string } | null;
}

const OperatorContactAddressEdit: React.FC = () => {
  const {
    merchants,
    merchantSalesChannels,
    currentMerchant,
    setCurrentMerchant,
    loading: globalLoading,
  } = useOperatorData();

  // 仿 pages/operator/Orders/Edit.jsx — 由 onContactAddressLoaded 取得 record 所屬 merchant
  // 後，主動把 OperatorDataContext.currentMerchant 切過去，merchantSalesChannels 會跟著
  // 自動切到正確 merchant 的清單。避免「header 選 merchant B 但編輯 merchant A 的地址」時
  // sales_channel_id 下拉用錯 merchant 過濾。
  const [recordMerchantId, setRecordMerchantId] = useState<string | null>(null);

  const handleContactAddressLoaded = useCallback((record: ContactAddressLoadedPayload) => {
    const merchantId = record.merchant_id ?? record.merchant?.id ?? null;
    if (merchantId) {
      setRecordMerchantId(merchantId);
    }
  }, []);

  useEffect(() => {
    if (!recordMerchantId || merchants.length === 0) return;
    if (recordMerchantId === currentMerchant?.id) return;
    const matched = merchants.find(m => m.id === recordMerchantId);
    if (matched) setCurrentMerchant(matched);
  }, [recordMerchantId, merchants, currentMerchant?.id, setCurrentMerchant]);

  // record merchant 已知但 currentMerchant 還沒對齊 → 顯示 loading 擋住表單，避免 channel 下拉用錯 merchant 閃一下
  const merchantDataLoading = globalLoading || (!!recordMerchantId && recordMerchantId !== currentMerchant?.id);

  return (
    <ContactAddressEdit
      contactAddressService={contactAddressService}
      role="operator"
      salesChannels={merchantSalesChannels}
      onContactAddressLoaded={handleContactAddressLoaded}
      merchantDataLoading={merchantDataLoading}
    />
  );
};

export default OperatorContactAddressEdit;
